import React from "react";
import classes from "./PromotionCard.module.css";
import Popover from "../Popovers";
import { AeroPlaneIcon } from "../../constant";
import { formattedDate } from "../../helpers";
const PromotionCard = ({data,menuList}) => {

  const message = JSON?.parse(data?.message)
  console.log("message", message)
 
  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <h2 className={classes.heading}>{message?.Title}</h2>
       {menuList}
      </div>  
      <p className={classes.shortDescription}>{message?.Data}</p>
      <p className={classes.description}>
        {message?.Notification}
      </p>
      <p className={classes.date}>{formattedDate(message?.Date)}</p>
    </div>
  );
};

export default PromotionCard;
